import { useBrokersServiceBrokersUsersResetPasswordCreate } from '@insurance/api/queries'
import { getFullName, showApiErrors } from '@shared/utils'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonPropsAgent } from './types'

export const ResetAgentPassword = ({
  data,
  onSuccess,
  open,
  onCancel
}: CommonPropsAgent) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()

  const { mutateAsync: resetPasswordMutation } =
    useBrokersServiceBrokersUsersResetPasswordCreate({
      onSuccess: () => {
        message.success(t('reset_password_successfully'))

        onSuccess()
      },
      onError: (error) => showApiErrors(error)
    })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('reset_password_confirm'),
      content: (
        <span
          dangerouslySetInnerHTML={{
            __html: t('reset_password_confirm_description_agent', {
              name: getFullName(data)
            })
          }}
        />
      ),
      okText: t('reset'),
      okType: 'danger',
      onOk: () => resetPasswordMutation({ id }),
      open,
      onCancel
    })

    return destroy
  }, [data, resetPasswordMutation, modal, onCancel, open, t])

  return contextHolder
}
